import React from "react";
import { Alert } from 'antd';

const Notify = ({message, variant}) => {
    return(
        <Alert message={message} type={variant} style={{marginTop: "10px", marginBottom: "10px"}}/>
    );
}

export default Notify;